exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.adp-competences[data-v-6aafdb28] {\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 2px;\n  padding: 20px;\n}\n.competence-header[data-v-6aafdb28] {\n  display: flex;\n  border-bottom: 1px solid #CCCCCC;\n  margin: 0 -20px;\n  padding: 0 17px 13px;\n}\n.tree-block[data-v-6aafdb28] {\n  margin: 40px 30px;\n}\n", ""]);

// exports
